import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { SequenceInstructionItem, ApprovalBE, PkgInstrPruRelationBE } from '../sequence-instruction/shared/sequence-instruction.model';

@Injectable()
export class SequenceInstructionService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'SequenceInstruction';
    private apiNotImplementedUrl: string = this.config.get('apiUrl') + 'NotImplementedYet';

    getInstruction(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetSequenceInstructionFor/?seqInstructionId=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteInstruction(id: number, deleteMessage: string, userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteSequenceInstruction?seqInstructionId=${id}&deleteMessage=${deleteMessage}&userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    saveInstruction(instruction: SequenceInstructionItem): Observable<IReturnObject> {
      let headers: Headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let body = JSON.stringify(instruction);
      let options = new RequestOptions({ headers: headers });

      return this.http.post(`${this.apiUrl}/SaveSequenceInstruction`, body, options)
          .map((response: Response) => <IReturnObject>response.json());
  }

  sendSequenceInstructionForApproval(approvalBE: ApprovalBE): Observable<IReturnObject> {
      let headers: Headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let body = JSON.stringify(approvalBE);
      let options = new RequestOptions({ headers: headers });

      return this.http.post(`${this.apiUrl}/SendSequenceInstructionForApproval`, body, options)
          .map((response: Response) => <IReturnObject>response.json());
  }

  getInstructionList(searchTerm: string, supplierNumber: string, extendedSupplierNumber: string, isSupplier: boolean, instructionType: number): Observable<IReturnObject> {
      let url = `${this.apiUrl}/GetSequenceInstructionList/?searchTerm=${searchTerm}`
          + `&supplierNumber=` + supplierNumber
          + `&extendedSupplierNumber=` + extendedSupplierNumber
          + `&isSupplier=` + isSupplier;
          + `&instructionType=` + instructionType;
      return this.http.get(url)
          .map((response: Response) => <IReturnObject>response.json());
  }
  existsContactsForSendForApproval(supplierNos: string): Observable<IReturnObject> {
    return this.http.get(`${this.apiUrl}/SupplierEmailExists/?suppliers=${supplierNos}`)
        .map((response: Response) => <IReturnObject>response.json());
}

  getLevelConstraintData(constraintCodeId: number, mainCodeId: number): Observable<IReturnObject> {
      return this.http.get(`${this.apiUrl}/GetLevelConstraintData/?constraintCodeId=${constraintCodeId}&mainCodeId=${mainCodeId}`)
          .map((response: Response) => <IReturnObject>response.json());
  }

  getNewLevelInfoFor(codeId: number): Observable<IReturnObject> {
      return this.http.get(`${this.apiUrl}/GetNewLevelInfoFor/?codeId=${codeId}`)
          .map((response: Response) => <IReturnObject>response.json());
  }

  getPreviewPdf(id: number, siName: string): Observable<any> {
      return this.http.get(`${this.apiUrl}/GetPreviewPdfSI/?siId=${id}&siName=${siName}`);
      //.map((response: Response) => response.json());
  }

  siNameExist(siName: string): Observable<boolean> {
      return this.http.get(`${this.apiUrl}/SINameExist/?siName=${siName}`)
          .map((response: Response) => <boolean>response.json());
  }

  GetSiName(siName: string, id: number): Observable<string> {
      return this.http.get(`${this.apiUrl}/GetSIName/?siName=${siName}&id=${id}`)
          .map((response: Response) => <string>response.json());
  }

  getPruList(): Observable<IReturnObject> {
      return this.http.get(`${this.apiUrl}/GetPruList`)
          .map((response: Response) => <IReturnObject>response.json());
  }


  scrapSeqInstr(seqInstrId: number): Observable<IReturnObject> {
      return this.http.get(`${this.apiUrl}/ScrapSeqInstr/?seqInstrId=${seqInstrId}`)
          .map((response: Response) => <IReturnObject>response.json());
  }

  isFirstSIWithPnl(instruction: SequenceInstructionItem): Observable<IReturnObject> {
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    let body = JSON.stringify(instruction);
    let options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/IsFirstSIWithPnl`, body, options)
        .map((response: Response) => <IReturnObject>response.json());
}
  checkConflict(instruction: SequenceInstructionItem): Observable<IReturnObject> {
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    let body = JSON.stringify(instruction);
    let options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/CheckConflict`, body, options)
      .map((response: Response) => <IReturnObject>response.json());
  }
  UncheckPruRelationforSI(pkgInstrPruRelationBE: PkgInstrPruRelationBE, siname: string): Observable<IReturnObject> {
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    let body = JSON.stringify(pkgInstrPruRelationBE);

    var bodyUpdated = JSON.parse(body);
    bodyUpdated['siname'] = siname;

    let options = new RequestOptions({ headers: headers });

    return this.http.post(`${this.apiUrl}/UncheckPruRelationforSI`, body, options)
      .map((response: Response) => <IReturnObject>response.json());

  }
}




// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/sequence-instruction/sequence-instruction.service.ts